export default Object.freeze({
  ADMIN: 'ADMIN',
  PRACTITIONER: 'PRACTITIONER',
});
